import { render } from "./Contribute.vue?vue&type=template&id=df206f66&scoped=true"
import script from "./Contribute.vue?vue&type=script&lang=js"
export * from "./Contribute.vue?vue&type=script&lang=js"

import "./Contribute.vue?vue&type=style&index=0&id=df206f66&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-df206f66"

export default script